import { View, Text, Image, Dimensions } from "react-native";
import React, { useEffect } from "react";
import { happyKidsJumping } from "../../imports";
import { useDispatch, useSelector } from "react-redux";
import { useIsFocused } from "@react-navigation/native";
import {
  changeHeaderColor,
  hideBackButton,
} from "../../redux/header/headerAction";
import { RefreshControl, ScrollView } from "react-native-gesture-handler";
import CategoryItem from "../../components/tutorial/CategoryItem";
import getTutorialCategoryList from "../../api/tutorial/getTutorialCategories";
import { useState } from "react";

export default function TutorialCategories() {
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const [items, setItems] = useState([]);
  const [refreshing, setRefreshing] = useState(true);

  useEffect(() => {
    if (refreshing) {
      getTutorialCategoryList(1000, 1)
        .then(({ data }) => {
          setRefreshing(false);
          return data.status === 200 ? setItems(data.data) : null;
        })
        .catch(() => {});
    }
  }, [refreshing]);
  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#93E5F0"));
    }
  }, [isFocused]);
  return (
    <ScrollView
      refreshControl={
        <RefreshControl
          refreshing={refreshing}
          onRefresh={() => setRefreshing(true)}
        />
      }
      style={{ height: "100%", backgroundColor: "#9FCC3B" }}
      showsVerticalScrollIndicator={false}
      scrollEventThrottle={1000}
      onScroll={(event) => {
        let y = event.nativeEvent.contentOffset.y;

        if (isFocused) {
          if (y > 200) {
            dispatch(changeHeaderColor("#9FCC3B"));
          } else {
            dispatch(changeHeaderColor("#93E5F0"));
          }
        }
      }}
    >
      <View
        style={{
          height: Dimensions.get("window").height,
          marginTop: -1 * Dimensions.get("window").height,
          backgroundColor: "#93E5F0",
          width: "100%",
        }}
      ></View>
      <View style={{ width: "100%" }}>
        <Image
          style={{
            width: "100%",
            height: (Dimensions.get("screen").width * 432) / 612,
          }}
          resizeMode="contain"
          source={happyKidsJumping}
        />
      </View>
      <View style={{ width: "100%", alignItems: "center" }}>
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {items.map(
            (category, index) =>
              category.active === "active" && (
                <CategoryItem
                  id={category.id}
                  image={category.picUrl}
                  name={main.rtl ? category.nameFa : category.nameEn}
                  key={index}
                
                />
              )
          )}

          <View
            style={{ width: Dimensions.get("window").width / 3 + 25 }}
          ></View>
        </View>
      </View>
      <View style={{ height: 100 }}></View>
    </ScrollView>
  );
}
